module.exports = __webpack_public_path__ + "static/media/favoritesActive.abe964af.svg";